module.exports = __webpack_public_path__ + "img/FrancoBat.fb27d78b.jpg";